export default __webpack_public_path__ + "static/media/booth_info_re.3f9daabd.svg";